import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, BasicFileInput, DatePickerField } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

const ImportCreateTemplate = defaultTemplate (({ editView }) => {
    const {
        contentLoading,
        form,
        facilityStore,
        nextDeliveryDates,
        updateScheduledDate
    } = editView;

    const dates = nextDeliveryDates ? nextDeliveryDates.map(i => {
        const deliveryDate = i.deliveryDate;
        const dateOfService = i.parentFacilityScheduleDate && i.parentFacilityScheduleDate.dateOfService;
        return (
            <div className="u-mar--bottom--sml" key={i.id}>
                <a onClick={() => updateScheduledDate(deliveryDate, dateOfService)}>{i.name}</a> 
            </div>
        );
    }
    ) : [];

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BasicFileInput field={form.$('file')} />
                                </div>    
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('facility')} store={facilityStore}/>
                                </div>         
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <DatePickerField field={form.$('scheduledDate')}/>
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <DatePickerField field={form.$('dateOfService')}/>
                                </div>
                                {nextDeliveryDates && nextDeliveryDates.length > 0 && <div className="form__group col col-lrg-6 u-mar--bottom--sml u-mar--top--sml">
                                    <h4 className='u-mar--bottom--sml'>Next Delivery Dates</h4>
                                    {dates}
                                </div>}
                            </div>                 
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}
);

ImportCreateTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
}

export default ImportCreateTemplate;
